import React from 'react';
import { useNavigate } from 'react-router-dom';
import FranchiseInventory from '../components/FranchiseInventory';
import BottomNavigation from '../components/BottomNavigation';
import LanguageSelector from '../components/LanguageSelector';
import { ArrowLeft } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function FranchiseInventoryPage({ user }) {
  const navigate = useNavigate();
  const franchiseId = user?.franchise?.id;
  const authToken = localStorage.getItem('authToken');
  const features = user?.franchise?.features || {};

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <div className="sticky top-0 z-30 bg-surface border-b border-border px-4 py-3">
        <div className="flex items-center gap-3">
          <button onClick={() => navigate('/franchise/dashboard')} className="p-1" data-testid="inv-back-btn">
            <ArrowLeft className="w-5 h-5 text-muted-foreground" />
          </button>
          <h1 className="text-lg font-bold text-primary flex-1">Inventory</h1>
          <LanguageSelector />
        </div>
      </div>

      {/* Content */}
      <div className="p-4">
        <FranchiseInventory franchiseId={franchiseId} authToken={authToken} />
      </div>

      {/* Bottom Navigation */}
      <BottomNavigation
        activeTab="inventory"
        setActiveTab={() => {}}
        features={features}
        onAttendanceClick={() => {}}
      />
    </div>
  );
}
